
import useFetchProvider from 'hooks/useFetchProvider';

const CampaignService = ()=>{
    const fetch = useFetchProvider();
    const createCampaign = async(data)=> await fetch.post(`/Campaign/`, data);
    const updateTitle = async(id, title)=> await fetch.patch(`/Campaign/${id}/Name`, {ID:id, Title: title});
    const hideCampaign = async(id) => await fetch.patch(`/Campaign/${id}/Hide`);
    const createPromoCode = async(id, code) => await fetch.post(`/Campaign/${id}/PromoCode/`, {ID:id, Code:code});
    const extendPromoCode = async(id) => await fetch.patch(`/Campaign/${id}/PromoCode/Extend`, {ID:id});
    const updatePromoCodeName = async(id, code) => await fetch.patch(`/Campaign/${id}/PromoCode/Code`, {ID:id, Code:code });

    return {createCampaign, hideCampaign, createPromoCode, extendPromoCode, updateTitle, updatePromoCodeName}
}

export default CampaignService;